import {createSlice} from "@reduxjs/toolkit";

export const onboardSlice = createSlice({
    name: 'onboard',
    initialState: {
        activeStep: 0,
        totalStep: 3,
    },
    reducers: {
        nextStep: (state) => {
            state.activeStep = state.activeStep < state.totalStep ? state.activeStep + 1 : state.activeStep
        },
        prevStep: (state) => {
            state.activeStep = state.activeStep > 0 ? state.activeStep - 1 : state.activeStep
        }
    },
});

export const {nextStep, prevStep} = onboardSlice.actions;
export default onboardSlice.reducer;